import { render, staticRenderFns } from "./Profile.Edit.vue?vue&type=template&id=21dabf10&scoped=true"
import script from "./Profile.Edit.vue?vue&type=script&lang=js"
export * from "./Profile.Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dabf10",
  null
  
)

export default component.exports